__turbopack_context__.v({
  "avatar": "avatar-module-scss-module__CKuQqq__avatar",
  "avatar__isSquare": "avatar-module-scss-module__CKuQqq__avatar__isSquare",
});
